import React, { PropsWithChildren } from 'react';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { PropsWithTestId } from 'types';

export type TabProps = PropsWithChildren<PropsWithTestId<{
  id: string | undefined;
  label: string;
  isFullScreen?: boolean;
  borderless?: boolean;
  /** When `true`, the in-panel `<h2>` title is not rendered (e.g. when it would duplicate the tab label). Defaults to `false`. */
  hideTitle?: boolean;
}>>;

export default function Tab({ id, label, children, testId, isFullScreen, borderless, hideTitle }: TabProps) {
  const className = buildClassName(styles.component, isFullScreen && styles['component-full-screen'], borderless && styles.borderless);
  return (
    <div id={id} className={className} data-testid={testId}>
      {!isFullScreen && !hideTitle && <h2 className={styles.title}>{label}</h2>}
      {children}
    </div>
  );
}
